
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/app/payment",
      function () {
        return require("private-next-pages/[locale]/app/payment.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/app/payment"])
      });
    }
  